/**
 * @ngdoc service
 * @name kareo.ui.shared.assets:PatientCreateModalService
 * @description
 * Launch patient create modal
 *
 * @example
 <example module="patientCreateDemo">
 <file name="index.html">
 <div ng-controller="PatientCreateDemoCtrl" class="kareo" >
   <button ng-click="createPatient()">Create Patient</button>
   <patient-create-modal/>
 </div>
 </file>
 <file name="demo.js">
 var app = angular.module('patientCreateDemo', ['kareo.ui.shared.directives.patient-create']);

 app.controller('PatientCreateDemoCtrl', ['$scope', 'PatientCreateModalService', function($scope, PatientCreateModalService){
       $scope.createPatient = function(){
        PatientCreateModalService.launch();
       };
     }]);
 </file>
 </example>
 */
angular
  .module('kareo.ui.shared.directives.patient-create.services', [
    'kareo.ui.shared.modules.api.patient-service'
  ])
  .factory('PatientCreateModalService', [
    '$q',
    function PatientCreateModalService($q) {
      var deferred, open, patientModal = {};

      open = false;

      patientModal.isOpen = function () {
        return open;
      };

      patientModal.launch = function () {
        open = true;
        deferred = $q.defer();
        return deferred.promise;
      };
      patientModal.close = function () {
        open = false;
        if (deferred) {
          deferred.reject('canceling operation');
        }
      };
      patientModal.patientCreated = function (data) {
        if (deferred) {
          deferred.resolve(data);
        }
        open = false;
      };
      return patientModal;
    }])
  .factory('PatientManagementService', [
    'patientService',
    function PatientManagementService(patientService) {
      var svc = Object.create(patientService);
      // maintain old contract
      svc.savePatient = svc.createPatient;
      return svc;
    }
  ]);
